import { CostBreakdown } from '../components/pages/checkout/CheckoutForm/types/CostBreakdown';
import { roundToTwoDecimals } from './helpers';

export function calculateTotalWithoutVAT(total: number, taxPercentage: number) {
  return (1 / (1 + taxPercentage / 100)) * total;
}

export const calculateCostBreakdown = (
  shippingCost: number,
  totalBasePrice: number,
  totalDiscount: number,
  taxPercentage?: number,
  taxAmount?: number,
): CostBreakdown => {
  const subtotalPlusShipping = totalBasePrice + shippingCost - totalDiscount;

  // When taxAmount is provided (US/TaxJar), prices are netto and tax is added on top.
  // When taxAmount is not provided (EU), prices are gross and already include tax.
  const rawTax = taxAmount ?? subtotalPlusShipping - roundToTwoDecimals(
    calculateTotalWithoutVAT(subtotalPlusShipping, taxPercentage as number),
  );
  // Round to 2 decimals and normalize -0 / tiny negatives to 0
  const tax = roundToTwoDecimals(rawTax) || 0;
  const total = taxAmount != null
    ? subtotalPlusShipping + taxAmount
    : subtotalPlusShipping;
  const totalWithoutTax = total - tax;

  return {
    shipping: shippingCost,
    subtotal: totalBasePrice,
    totalSavings: totalDiscount,
    tax,
    totalWithoutTax: roundToTwoDecimals(totalWithoutTax),
    total,
  };
};
